import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import VerbHeading from '../../../shared/components/VerbHeading';
import VerbParagraph from '../../../shared/components/VerbParagraph';
import VerbButton from '../../../shared/components/VerbButton';

const DiscoverRowWrapper = ({
    currentCategory,
    index,
    children,
    userCompany,
    className,
    categories = [],
}) => (
    <div className={'collection-row'}>
        <div className={'container discover-row-wrapper'}>
            <VerbHeading
                hNumber={5}
                formatIntl={false}
                customMessage={currentCategory.label && currentCategory.label}
            />
            {currentCategory.subtext ? (
                <VerbParagraph
                    className={'category-subtext'}
                    formatIntl={false}
                    customMessage={currentCategory.subtext}
                />
            ) : null}
            <div className={cns('row', className)}>
                <div className={'col-12'} style={{ padding: '0' }}>
                    {children}
                </div>
            </div>
            {(index === userCompany?.customDiscover?.categories?.length - 1 || (index === categories.length - 1))  &&
            (
                <div className={'browse-collection-button-container'}>
                    <VerbButton
                        href={'/explore'}
                        textId={'BUTTON_BROWSE_ALL_COLLECTIONS'}
                        defaultMessage={'BROWSE ALL PATHS'}
                        className={'browse-collection-button col-12'}
                    />
                </div>
            )}
        </div>
    </div>
);

DiscoverRowWrapper.propTypes = {
    currentCategory: PropTypes.object,
    userCompany: PropTypes.object,
    index: PropTypes.number,
    children: PropTypes.any,
    className: PropTypes.string,
    categories: PropTypes.array,
};

export default DiscoverRowWrapper;
